import { Divider, Stack } from '@mui/material';
import { useState } from 'react';

import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { CustomButton } from '@/shared/components/custom-button';
import CustomModal from '@/shared/components/custom-modal';
import { CustomTextField } from '@/shared/components/custom-text-field';
import { formatWithoutFraction } from '@/utils/numbers/formatters';

export type CustomRangeProps = {
  setCustomRange: (_s: string) => void;
};

export const CustomRangeModal = () => {
  const { handleClose, open, props } = useGlobalModal('CUSTOM_RANGE_MODAL');
  const [minValue, setMinValue] = useState<string>('');
  const [maxValue, setMaxValue] = useState<string>('');

  const isInputsFilled = !!minValue && !!maxValue;

  const handleNumberChange = (value: string, setter: (_v: string) => void) => {
    if (/^-?\d*$/.test(value)) {
      setter(value);
    }
  };

  const handleApply = () => {
    if (isInputsFilled) {
      props?.setCustomRange(
        `${formatWithoutFraction(minValue)} - ${formatWithoutFraction(maxValue)}`,
      );
      handleClose();
      setMinValue('');
      setMaxValue('');
    }
  };

  return (
    <CustomModal open={open} onClose={handleClose} title="Custom Range" withCloseButton>
      <Stack mt="16px" flexDirection="column" gap="24px">
        <Divider />
        <Stack gap="16px" width="100%">
          <CustomTextField
            label="Min"
            bigLabel
            labelColor="text.secondary"
            placeholder="Enter min range"
            value={minValue}
            onChange={(e) => handleNumberChange(e.target.value, setMinValue)}
          />
          <CustomTextField
            label="Max"
            bigLabel
            labelColor="text.secondary"
            placeholder="Enter max range"
            value={maxValue}
            onChange={(e) => handleNumberChange(e.target.value, setMaxValue)}
          />
        </Stack>

        <CustomButton
          variant={isInputsFilled ? 'contained' : 'text'}
          sx={{ height: 40, fontWeight: 500, color: isInputsFilled ? 'inherit' : '#FFFFFF80' }}
          onClick={handleApply}
          disabled={!isInputsFilled}
        >
          Apply
        </CustomButton>
      </Stack>
    </CustomModal>
  );
};
